import Box from '@mui/material/Box';
import mvServiceSvg from '../../assets/mvideo.svg';
import acServiceSvg from '../../assets/service-ac.svg';
import callingServiceSvg from '../../assets/service-calling.svg';
import rcServiceSvg from '../../assets/service-rc.svg';
import { SERVICE } from '../../config/devices';
import { helpers } from '../../modules/devices';
import ItemService from './ItemService';

export type Device = { services: { [key in SERVICE]: { active: boolean } }[] };

interface IIconServices {
  device: Device;
  hasActivableGSMService?: boolean;
}

function IconServices({ device, hasActivableGSMService }: IIconServices) {
  return (
    <Box display="flex">
      <ItemService
        active={
          helpers.isActiveService(device, SERVICE.MOBILE_VIDEO) || helpers.isActiveService(device, SERVICE.LOCAL_CALLS)
        }
        image={mvServiceSvg}
        service={SERVICE.MOBILE_VIDEO}
      />
      {hasActivableGSMService && (
        <ItemService
          active={helpers.isActiveService(device, SERVICE.GSM_CALLS)}
          image={callingServiceSvg}
          service={SERVICE.GSM_CALLS}
        />
      )}
      <ItemService
        active={helpers.isActiveService(device, SERVICE.ACCESS_CONTROL)}
        image={acServiceSvg}
        service={SERVICE.ACCESS_CONTROL}
      />
      <ItemService
        active={helpers.isActiveService(device, SERVICE.REMOTE_CONFIGURATION)}
        image={rcServiceSvg}
        service={SERVICE.REMOTE_CONFIGURATION}
      />
    </Box>
  );
}

export default IconServices;
